export default {
      id: "icon-vk-usage",
      viewBox: "0 0 101 100",
      url: __webpack_public_path__ + "assets/template/sprite/sprite.svg#icon-vk",
      toString: function () {
        return this.url;
      }
    }